<template>
  <div>
    <a-form-model ref="ruleForm" :layout="layout" :model="form" :rules="rules">
      <a-form-model-item label="试题内容：" prop="name">
        <a-input v-model="form.name" type="textarea" />
      </a-form-model-item>
      <!-- <a-form-model-item label="关联项：" prop="relevance">
        <a-select
          mode="multiple"
          v-model="form.relevance"
          placeholder="请选择关联项"
          :options="relevanceOptions"
        />
      </a-form-model-item> -->
      <a-form-model-item
        class="add-input"
        v-for="(item, index) in form.topicOptions"
        :key="index"
        :label="index === 0 ? '题目选项：' : ''"
        :prop="'topicOptions.' + index + '.value'"
        :rules="{
          required: true,
          message: `题目选项${formatletter(index)}不能为空`,
          trigger: 'blur',
        }"
      >
        <a-input v-model="item.value" :addon-before="formatletter(index)" placeholder="请输入">
          <div slot="addonAfter" style="width: 100px">
            <span>分值：</span>
            <a-input-number
              v-model="item.score"
              style="width: 71px"
              @change="changeeScore(item, index)"
            />
          </div>
        </a-input>
        <a-icon
          v-if="index == form.topicOptions.length - 1 && index > 0"
          class="dynamic-delete-button"
          type="delete"
          :style="{ fontSize: '22px', color: '#999' }"
          @click="removeDomain(item)"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="dashed" block @click="addDomain">
          <a-icon type="plus" />
          新增选项
        </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <a-button
          v-if="Object.keys(editFormRecord).length"
          style="margin-right: 10px"
          @click="cancelEdit"
        >
          取消
        </a-button>
        <a-button type="primary" @click="onSubmit">保存</a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { postAction, putAction } from '@api/manage'
const topicOptions = [
  {
    value: '有',
    score: 0,
  },
  {
    value: '无',
    score: 1,
  },
  {
    value: '或许',
    score: 2,
  },
  {
    value: '大概',
    score: 3,
  },
]
export default {
  name: 'SingleChoice',
  props: {
    evaluationId: {
      type: String,
      default: '',
    },
    editFormRecord: {
      type: Object,
      default: () => ({}),
    },
    // 插入题目序号，大于0才是插入题目
    insertNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      layout: 'vertical',
      form: {
        name: '',
        // relevance: [],
        topicOptions,
      },
      // relevanceOptions: [
      //   { label: '学习好', value: '学习好' },
      //   { label: '情绪稳定', value: '情绪稳定' },
      //   { label: '家庭条件', value: '家庭条件' },
      //   { label: '工作压力', value: '工作压力' },
      //   { label: '身体健康', value: '身体健康' },
      //   { label: '兴趣爱好', value: '兴趣爱好' },
      //   { label: '其他', value: '其他' },
      // ],
      rules: {
        name: [{ required: true, message: '请输入试题内容', trigger: 'blur' }],
        relevance: [{ required: true, message: '请选择关联项', trigger: 'blur' }],
      },
    }
  },
  watch: {
    editFormRecord: {
      handler(newVal) {
        console.log('编辑记录--', newVal)

        if (Object.keys(newVal).length) {
          this.form = {
            ...newVal,
            topicOptions: newVal.schoolEvaluationAnswerOptionsList.map((item) => ({
              questionId: item.id,
              value: item.name,
              score: item.score,
            })),
          }
          return
        }
        this.resetForm()
      },
      immediate: true,
    },
  },
  methods: {
    addDomain() {
      this.form.topicOptions.push({
        value: '',
        score: this.form.topicOptions[this.form.topicOptions.length - 1].score + 1,
      })
    },
    formatletter(index) {
      let keyStr = String.fromCharCode(65 + index)
      return keyStr
    },
    removeDomain(item) {
      let index = this.form.topicOptions.indexOf(item)
      if (index !== -1) {
        this.form.topicOptions.splice(index, 1)
      }
    },
    changeeScore(item, index) {
      // console.log('表单数据', this.form)
      // console.log('修改分值：', item, index)
    },
    cancelEdit() {
      this.$emit('cancelEdit')
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        const schoolEvaluationAnswerOptionsList = this.form.topicOptions.map((item) => ({
          questionId: item.questionId || '',
          name: item.value,
          score: item.score,
        }))
        const currRecord = {
          evaluationId: this.evaluationId,
          id: this.editFormRecord.id,
          name: this.form.name,
          schoolEvaluationAnswerOptionsList,
        }
        // console.log('参数信息：', currRecord)
        if (Object.keys(this.editFormRecord).length) {
          putAction('/schoolEvaluationQuestion/edit', currRecord).then((res) => {
            if (res.success) {
              this.$message.success('编辑成功')
              this.$emit('refreshData')
            }
          })
          return
        }
        postAction('/schoolEvaluationQuestion/add', currRecord).then((res) => {
          if (res.success) {
            this.$message.success('新增题目成功')
            this.$emit('refreshData')
          }
        })
        // const index = quesTableList.findIndex(
        //   (item) => item.id && item.id == this.editFormRecord.id
        // )
        // console.log('提交信息：', this.form, '更新的索引', index)
        // if (index !== -1) {
        //   quesTableList.splice(index, 1, { ...quesTableList[index], ...this.form })
        //   console.log('更新后的列表信息：', quesTableList)
        //   localStorage.setItem('quesTableList', JSON.stringify(quesTableList))
        //   // this.$emit('refreshData', 'edit');
        // } else {
        //   // 插入题目
        //   // if (this.insertNum > 0) {
        //   //   quesTableList.splice(this.insertNum - 1, 0, currRecord)
        //   //   return
        //   // }
        //   // 新增题目
        // }
        // this.$emit('refreshData')
        // console.log('最新的列表信息：', this.quesTableList);
      })
    },
    resetForm() {
      this.form = {
        name: '',
        topicOptions,
      }
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
  },
}
</script>
<style scoped lang="less">
.add-input {
  /deep/ .ant-form-item-children {
    display: flex;
    align-items: center;
    .ant-input {
      flex: 1;
    }
    .anticon-delete {
      width: 28px;
    }
  }
}
</style>
